export function initialDataParser(module, variables) {
  return variables.reduce((result, variableName) => {
    const input = document.querySelector(
      `input[name='${module}-${variableName}']`,
    );
    if (input) {
      result[variableName] = JSON.parse(input.getAttribute('value') || '');
    }

    return result;
  }, {});
}

export function initialDataParserFromElement({ dataset }) {
  return Object.keys(dataset).reduce((result, variableName) => {
    try {
      result[variableName] = JSON.parse(dataset[variableName] || '');
    } catch (e) {
      result[variableName] = dataset[variableName];
    }
    return result;
  }, {});
}
